const HelpCircleIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2616_39549)">
        <path
          d="M7.5724 7.4974C7.76832 6.94045 8.15502 6.47082 8.66403 6.17167C9.17303 5.87253 9.77148 5.76318 10.3534 5.86299C10.9353 5.9628 11.4631 6.26533 11.8433 6.717C12.2235 7.16867 12.4316 7.74033 12.4307 8.33073C12.4307 9.9974 9.93073 10.8307 9.93073 10.8307M9.9974 14.1641H10.0057M18.3307 9.9974C18.3307 14.5998 14.5998 18.3307 9.9974 18.3307C5.39502 18.3307 1.66406 14.5998 1.66406 9.9974C1.66406 5.39502 5.39502 1.66406 9.9974 1.66406C14.5998 1.66406 18.3307 5.39502 18.3307 9.9974Z"
          stroke="#F1F1F1"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2616_39549">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default HelpCircleIcon;
